import { getLocaleConfig, type Locale } from "@/config/locale";

/**
 * Hardcoded narrow symbols — identical on server (Node.js) and every browser.
 * Eliminates React hydration mismatches caused by differing ICU data versions.
 */
const NARROW_SYMBOLS: Record<string, string> = {
	AUD: "$",
	BRL: "R$",
	CAD: "$",
	CHF: "CHF",
	CNY: "¥",
	GBP: "£",
	HKD: "$",
	ILS: "₪",
	INR: "₹",
	JPY: "¥",
	KRW: "₩",
	MXN: "MX$",
	MYR: "RM",
	NOK: "kr",
	NZD: "$",
	PHP: "₱",
	SGD: "$",
	THB: "฿",
	TRY: "₺",
	USD: "$",
	ZAR: "R",
	CZK: "Kč",
	DKK: "kr",
	HUF: "Ft",
	ISK: "kr",
	PLN: "zł",
	RON: "lei",
	SEK: "kr",
	IDR: "Rp",
	EUR: "€",
};

/**
 * Narrow symbol for badges (€, $, zł, …) — safe for SSR/CSR.
 * Uses a hardcoded map to avoid Intl.NumberFormat hydration mismatches.
 */
export function getCurrencyNarrowSymbol(currencyCode: string, _locale: string): string {
	return NARROW_SYMBOLS[currencyCode] ?? currencyCode;
}

/** Localized currency name (e.g. "Euro", "US Dollar"). */
export function getCurrencyDisplayName(currencyCode: string, locale: string): string {
	try {
		const bcp47 = getLocaleConfig(locale as Locale).bcp47;
		return new Intl.DisplayNames([bcp47], { type: "currency" }).of(currencyCode) ?? currencyCode;
	} catch {
		return currencyCode;
	}
}
